import React, { RefObject } from "react";
import moment from "moment/moment";
import { isEmpty, map, some } from "lodash";
import { Appointment, Calendar } from "../../../../@types/appointments";
import CalendarDay from "components/appointments/appointmentsList/CalendarDay";

type CalendarWeekArgs = {
  week: string[];
  appointmentsByDate: { [date: string]: Appointment[] };
  calendars?: Calendar[];
  todayRef: RefObject<HTMLDivElement>;
};

export default function MobileCalendarWeek({
  week,
  appointmentsByDate,
  calendars,
  todayRef,
}: CalendarWeekArgs) {
  const weekNumber = moment(week[0]).startOf("week").add(3, "days").format("w");
  const isEmptyWeek = !some(appointmentsByDate, (appointments, date) => {
    return (
      moment(week[0]).startOf("week").isoWeek() ===
        moment(date).startOf("week").isoWeek() && !isEmpty(appointments)
    );
  });

  return (
    <div>
      <div className="flex justify-end items-center pb-5">
        <span className="bg-neutral/25 text-muted text-xs py-1 px-2 rounded">
          {weekNumber}
        </span>
      </div>
      <div className="calendar-week flex flex-col divide-neutral divide-y -mx-5">
        {isEmptyWeek ? (
          <div className="no-appointments flex justify-center items-center p-5 text-lg">
            {I18n.t("calendars.month_list.empty_week")}
          </div>
        ) : (
          map(week, (day) => {
            return (
              !isEmpty(appointmentsByDate[day]) && (
                <CalendarDay
                  key={day}
                  appointments={appointmentsByDate[day]}
                  day={day}
                  calendars={calendars}
                  todayRef={todayRef}
                />
              )
            );
          })
        )}
      </div>
    </div>
  );
}
